module.exports = __webpack_public_path__ + "fonts/NunitoSans-Regular.d795c8c.woff";